<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>web</md-icon>
        </div>
        <h4 class="title">
          Application ID
        </h4>
        <help-link :link="helpLink.link" title="app-id"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Application ID</label>
              <md-input
                readonly
                v-model="app.applicationId"
                data-tour="application_id"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js'
export default {
  props: {
    app: null,
    ogApp: null,
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.applicationConfig.applicationId
  }),
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>